module.exports = __webpack_public_path__ + "img/IL.033c38c0.svg";